import { useEffect, useState } from 'react'
import LiFiClient from '../../clients/LiFiClient'
import { EarnPosition } from '../../interfaces/earn'
import { logger } from '../../logger'
import useWallet from '../useWallet'

export const useEarnPositions = () => {
  const { wallet } = useWallet()
  const [positions, setPositions] = useState<EarnPosition[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!wallet.ethAddress) return

    setLoading(true)

    new LiFiClient()
      .getPositions(wallet.ethAddress)
      .then(setPositions)
      .catch((e) => logger.error('Failed to fetch earn positions', { originalError: e }))
      .finally(() => setLoading(false))
  }, [wallet.ethAddress])

  return { positions, loading }
}
